// import {createRouterMiddleware} from '@uirouter/redux'
import thunk from 'redux-thunk'
import {createLogger} from 'redux-logger'
import {loadingBarMiddleware} from 'react-redux-loading-bar'
import {configureStore} from '@reduxjs/toolkit'
import reducer from 'redux/reducer'

import {UIRouter} from '@uirouter/core'
import {TRIGGER_TRANSITION} from './router/routerActions'

export function createRouterMiddleware(router: UIRouter) {
  return () => next => action => {
    if (action.type !== TRIGGER_TRANSITION) {
      return next(action)
    }

    const {to, params, options} = action
    router.stateService.go(to, params, options)
  }
}

const createRoutedStore = (router, sagaMiddleware) => {
  // const routerMiddleware = createRouterMiddleware(router)

  return configureStore({
    reducer,
    devTools: __WEBPACK_ISDEV__,
    middleware: (getDefaultMiddleware) => {
      const middleware = getDefaultMiddleware({
        thunk: {
          extraArgument: router,
        },
        serializableCheck: {
          // Ignore these action types
          ignoredActions: [
            '@ui-router/START_TRANSITION',
            '@ui-router/FINISH_TRANSITION',
            '@ui-router/SUCCESS_TRANSITION',
            '@ui-router/REDIRECTED_TRANSITION',
            '@ui-router/IGNORED_TRANSITION',
            'persist/PERSIST',
            'IMMER_REDUCER:SpeedBump#withSpeedBump',
          ],
          // Ignore these field paths in all actions
          // ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
          // Ignore these paths in the state
          ignoredPaths: ['router'],
        },
      })
      // use of .concat seems to preserve types better than spreading arrays
      // https://github.com/reduxjs/redux-toolkit/issues/587#issuecomment-824952445
        .concat(
          loadingBarMiddleware({
            promiseTypeSuffixes: ['GO', 'OK', 'ERR'],
          })
        )
        .concat(thunk)
        .concat(sagaMiddleware)
        .concat(createRouterMiddleware(router))

      if (REDUX_SHOW_CONSOLE_LOGS) {
        middleware.concat(createLogger())
      }

      return middleware
    },
  })
}

export default createRoutedStore
